import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class TllBulkReservationSettingService extends BaseService {
  list = () => {
    return this.axios.get(API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_LIST, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
  };

  search = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value === null || value === undefined || value === "") {
        return;
      }
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return;
        }
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== "") {
            searchParams.append(key, item);
          }
        });
        return;
      }
      searchParams.append(key, value);
    });
    return this.axios.get(API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_SEARCH, {
      params: searchParams,
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
  };

  create = (data) => {
    return this.axios.post(API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_CREATE, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
  };

  getDetail = ({ batchCrawlSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_DETAIL.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  update = ({ batchCrawlSettingId, data }) => {
    return this.axios.put(
      API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_UPDATE.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      data,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  delete = ({ batchCrawlSettingId }) => {
    return this.axios.delete(
      API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_DELETE.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  execute = ({ batchCrawlSettingId }) => {
    return this.axios.post(
      API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_EXECUTE.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      {},
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  cancel = ({ batchCrawlSettingId }) => {
    return this.axios.post(
      API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_CANCEL.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      {},
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  getCurrent = ({ batchCrawlSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_CURRENT.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  getHistories = ({ batchCrawlSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.TLL_BULK_RESERVATION_SETTINGS_HISTORIES.replace(
        "{batchCrawlSettingId}",
        batchCrawlSettingId
      ),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };
}
